import React from 'react';
import Button from '@atlaskit/button';
import { Task, UserRole } from '@css-xp/apd-common';
import { useApplicationContext } from '@css-xp/base/common-context';
import './task-action-buttons.scss';
import { TaskAction, isActionAllowed } from './task-actions';

interface TaskActionButtonsProps {
  task: Task;
  userRole?: UserRole | null;
  onClick: (_action: TaskAction) => void;
}

export const testIds = {
  [TaskAction.APPROVE]: 'approve-btn',
  [TaskAction.DECLINE]: 'decline-btn',
  [TaskAction.REQUEST_REASONS]: 'request-reasons-btn',
  [TaskAction.REPLY]: 'reply-btn',
  [TaskAction.COMMENT]: 'comment-btn',
  [TaskAction.CANCEL_REQUEST]: 'cancel-request-btn',
  [TaskAction.ASSIGN_TASK]: 'assign-task-btn',
  [TaskAction.UNASSIGN_TASK]: 'unassign-task-btn',
  [TaskAction.CHANGE_ASSIGNEE]: 'change-assignee-dropdown',
};

export const TaskActionButtons: React.FC<TaskActionButtonsProps> = ({ task, userRole, onClick }) => {
  const user = useApplicationContext();
  const userId = user?.userId?.split('@')?.[0];
  const actions = React.useMemo(
    () =>
      [
        TaskAction.REPLY,
        TaskAction.APPROVE,
        TaskAction.DECLINE,
        TaskAction.REQUEST_REASONS,
        // TaskAction.COMMENT, // Comment is disabled for now. Will be re-enabled once we have better clarity on its integratio with slack
        TaskAction.CANCEL_REQUEST,
        TaskAction.ASSIGN_TASK,
        TaskAction.UNASSIGN_TASK,
      ]
        .filter((action) => isActionAllowed(action, task, userRole, userId))
        .map((action: TaskAction) => (
          <Button key={action} onClick={() => onClick(action)} testId={testIds[action]}>
            {action}
          </Button>
        )),
    [onClick, task, userId, userRole]
  );

  return <div className="task-action-buttons">{actions}</div>;
};
